module.exports = __webpack_public_path__ + "img/bell-ring.ae6b55ca.svg";